import React from "react";
import { FaChevronLeft, FaChevronRight, FaSearchPlus } from "react-icons/fa";

import getProductImageUrl from "../../utils/imageUtils";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductImageGallery = ({
  product,
  selectedImageIndex,
  imageZoom,
  zoomPosition,
  onPrevImage,
  onNextImage,
  onOpenLightbox,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  onSelectImage,
}) => {
  return (
    <div className={styles.productGallery}>
      <div
        className={styles.mainImageContainer}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
      >
        {product.images?.length > 1 && (
          <button
            className={`${styles.imageNav} ${styles.imageNavLeft}`}
            onClick={onPrevImage}
            type="button"
          >
            <FaChevronLeft />
          </button>
        )}
        <img
          className={`${styles.mainImage} ${imageZoom ? styles.zoomed : ""}`}
          src={getProductImageUrl(product.images?.[selectedImageIndex])}
          alt={product.name}
          onClick={onOpenLightbox}
          style={
            imageZoom
              ? { transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%` }
              : {}
          }
        />
        {product.images?.length > 1 && (
          <button
            className={`${styles.imageNav} ${styles.imageNavRight}`}
            onClick={onNextImage}
            type="button"
          >
            <FaChevronRight />
          </button>
        )}
        {product.images?.length > 1 && (
          <div className={styles.imageIndicator}>
            {selectedImageIndex + 1} / {product.images.length}
          </div>
        )}
        <button
          className={styles.zoomToggle}
          onClick={onOpenLightbox}
          title="View fullscreen"
          type="button"
        >
          <FaSearchPlus />
        </button>
      </div>

      {product.images?.length > 0 && (
        <div className={styles.thumbnails}>
          {product.images.map((img, index) => {
            const thumbSrc = getProductImageUrl(img);
            return (
              <div
                key={index}
                className={styles.thumbnailWrapper}
                onClick={() => onSelectImage(index)}
              >
                <img
                  className={`${styles.thumbnail} ${
                    index === selectedImageIndex ? styles.selected : ""
                  }`}
                  src={thumbSrc}
                  alt={`Thumbnail ${index + 1}`}
                />
                {index === selectedImageIndex && (
                  <div className={styles.thumbnailOverlay} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductImageGallery;
